<div
	class="layout-wrapper"
	[ngClass]="{
		'layout-overlay': menuMode === 'overlay',
		'layout-static': menuMode === 'static',
		'layout-slim': menuMode === 'slim',
		'layout-sidebar-dim': colorScheme === 'dim',
		'layout-sidebar-dark': colorScheme === 'dark',
		'layout-overlay-active': overlayMenuActive,
		'layout-mobile-active': staticMenuMobileActive,
		'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
		'p-input-filled': inputStyle === 'filled',
		'p-ripple-disabled': !ripple
	}"
	[class]="colorScheme === 'light' ? menuTheme : ''"
	[attr.data-theme]="colorScheme"
	(click)="onLayoutClick()"
>
	<div class="layout-content-wrapper">
		<app-topbar></app-topbar>

		<div class="layout-content">
			<router-outlet></router-outlet>
		</div>

		<app-footer></app-footer>
	</div>

	<!-- <app-config *ngIf="user && user.role === 6"></app-config> -->

	<app-menu></app-menu>

	<app-search></app-search>

	<app-rightmenu></app-rightmenu>

	<app-dealer-venue-tools *ngIf="venueToolsDisplay" [venueSelected]="venueService.subscriptionVenue.value"></app-dealer-venue-tools>

	<div class="layout-mask modal-in"></div>

	<p-dialog [(visible)]="userSessionTrigger" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
		<div class="d-flex">
			<div class="h3">Are you still there? Your session will time out in 5 minutes.</div>
		</div>
		<ng-template pTemplate="footer">
			<p-button
				pRipple
				styleClass="p-button-raised m-2"
				(click)="userService.userSessionExpirationNotification.unsubscribe(); navigationService.lastPageVisitDateTime = moment().valueOf()"
			>
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'face-smiling-hands']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
			<button type="button" pButton icon="pi pi-check" label="I'm still here"></button>
		</ng-template>
	</p-dialog>

	<p-dialog [(visible)]="displayAdvertisement" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
		<img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/commandCenterAdBanner.png" width="100%" height="auto" />
		<div class="d-flex flex-column">
			<div class="h3 text-center text-capitalize">Maintenance Scheduled!</div>
			<div class="text-center mt-4">CommandCenter will be undergoing maintenance on Tuesday November 16th, 2021</div>
			<div class="text-center mt-1">starting at 6:30 PM CST/5:30PM MST and lasting until approximately 8:30PM CST/7:30PM MST.</div>
			<div class="text-center mt-1">All ordering functions will be fully operable and POS services will not be effected.</div>
		</div>
	</p-dialog>

	<app-image-cropper></app-image-cropper>

	<p-overlayPanel #tableColumnOverlayPanelDisplay id="tableColumnOverlayPanelDisplay">
		<app-table-column-picker [tableModel]="app.tableColumnOverlayPanelContent"></app-table-column-picker>
	</p-overlayPanel>

	<app-release-notes *ngIf="releaseNoteUrl" [releaseNoteArticleUrl]="releaseNoteUrl" (hideReleaseNoteChange)="releaseNotesHide()"></app-release-notes>
</div>
